// VerifyEmail.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

// Configure axios with your API base URL
const BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = BASE_URL + 'auth/';

const VerifyEmail = () => {
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      // Extract token from hash URL when using HashRouter
      // This handles both the search part of the hash
      let token;
      
      if (location.search) {
        // If token is in the regular search params (BrowserRouter style)
        const params = new URLSearchParams(location.search);
        token = params.get('token');
      } else {
        // If token is after the hash (HashRouter style)
        // Extract everything after the ? in the hash path
        const hashSearch = location.hash.split('?')[1];
        if (hashSearch) {
          const hashParams = new URLSearchParams(hashSearch);
          token = hashParams.get('token');
        }
      }

      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link. No token provided.');
        return;
      }

      try {
        // Send the token to your backend API
        await axios.post(`${API_URL}verify-email/`, { token });
        setStatus('success');
        setMessage('Your email has been successfully verified! You can now log in.');
        
        // Navigate to login with success message
        navigate('/login', {
          state: {
            message: 'Email successfully verified. You can now log in.',
            messageType: 'success'
          }
        });
      } catch (error) {
        setStatus('error');
        if (error.response && error.response.data && error.response.data.detail) {
          setMessage(error.response.data.detail);
        } else {
          setMessage('An error occurred during email verification. Please try again.');
        }
      }
    };

    verifyEmail();
  }, [location, navigate]);

  // You can reuse the UI from the previous component
  return (
    <div className="logreg-back">
      <div className="box-con">
        <div className="box">
          <h1 className="form-title">Email Verification</h1>
          {status === 'verifying' && (
            <div className="message-group">
              <p>Verifying your email...</p>
              {/* You can add a loading spinner here */}
            </div>
          )}
          {status === 'success' && (
            <div className="message-group" style={{ backgroundColor: 'rgb(167, 221, 164)' }}>
              <p>{message}</p>
              <p>Redirecting to login page...</p>
            </div>
          )}
          {status === 'error' && (
            <div className="message-group" style={{ backgroundColor: 'rgb(221, 167, 164)' }}>
              <div className="svg-div-first">
                <svg style={{ color: 'rgb(213, 129, 161)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                </svg>
              </div>
              <p>{message}</p>
              <div className="button-wrap">
                <button className="login-but" onClick={() => navigate('/login')}>
                  Go to Login
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;